// New service class to handle ExternalUACID changes							20/10/2025 RB
import { Inject, Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { BasicResponse } from '../model/basic-response';
import { ExternalUACIDInterface } from '../model/external-uacid';

@Injectable({
	providedIn: 'root'
  })
  export class ExternalUacidService {
  
	private URL;
	headers: HttpHeaders;
  
	constructor(@Inject(ConfigService) private config: any, private httpClient: HttpClient) {
	  this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find((restUrl: any) => restUrl.api === 'PADM').url;
	  this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
	}
  
	getUserExternalUACID(obj: ExternalUACIDInterface): Observable<ExternalUACIDInterface> {
	  const headers = this.headers;
	  obj.id = Number(obj.id);
	  obj.externalUACID = Number(obj.externalUACID);
	  return this.httpClient.post<ExternalUACIDInterface>(`${this.URL}/useraccess/getexternaluacid`, obj, {headers}).pipe(catchError(this.handleError));
	}

	updateUserExternalUACID(obj: ExternalUACIDInterface): Observable<BasicResponse> {
		const headers = this.headers;
		obj.id = Number(obj.id);
		obj.externalUACID = Number(obj.externalUACID);
		return this.httpClient.post<BasicResponse>(`${this.URL}/useraccess/updateexternaluacid`, obj, {headers}).pipe(catchError(this.handleError));
	  }
  

	private handleError(error: HttpErrorResponse) {
		if (error.error instanceof ErrorEvent) {
		  console.error('An error occurred:', error.error.message);
		} else {
		  console.error(
			  `Backend returned code ${error.status}, ` + `body was: ${error.error}`
		  );
		}
		return throwError(error);
	  }

}
